const calculatePercent = (value: number, total: number) =>
  value && total ? `${Math.round((100 * value) / total)}%` : '0%';

export { calculatePercent };
